@import "../../../helpers/helpers";

.actionButton {
  padding: 6px 32px 4px 7px;
}

.wrap {
  padding-right: 30px;
}

.loading {
  cursor: progress;
}

.policy {
  margin: 10px 0 28px;

  p {
    margin: 10px 0;
  }
}

.input {
  margin: 16px 0;
  padding: 7px;
  width: 60px;
  max-width: 540px;
  font-size: 16px;
  line-height: 1.4;
  border: 1px solid black;
  border-radius: 0;
  @extend %sans-serif;
}

.button {
  @extend %button;
  @extend %sans-bold;
  font-size: 16px;
  background-color: white;
  margin-right: 20px;

  .loading & {
    opacity: 0.5;
    pointer-events: none;
  }
}
